import React, { useState, useEffect, useRef } from 'react';
import TableHeader from './TableHeader';
import styles from './Table.module.css';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import MoreMenu from './MoreMenu';

const Table = ({
  parent,
  data,
  columns,
  checkBox,
  action,
  icons,
  selectData,
  handleSelectData,
  getRowStyle,
  check,
  fixed,
  scrollLeft,
  setScrollLeft,
  topScroll,
  mini,
  noGap,
  scroll,
  height,
  width,
  stickyHeader,
  maxHeight,
  wrapperRef,
  componentName,
  minWidth,
  tableWrapperWidth,
}) => {
  const [selectedData, setSelectedData] = useState([]);
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);
  const [scrollLeftInside, setScrollLeftInside] = useState('-24px');
  const [tableBodyWidth, setTableBodyWidth] = useState(0);
  const tableBodyRef = useRef(null);
  const tableContainerRef = useRef(null);

  const getCellValue = (col, val, row) => {
    if (col.component) {
      return <col.component value={val} {...row} />;
    }
    return val;
  };
  const handleSelectedData = (RowId) => {
    if (!selectedData?.includes(RowId)) {
      setSelectedData((prevSelected) => [...prevSelected, RowId]);
    } else {
      setSelectedData((prevSelected) =>
        prevSelected.filter((id) => id !== RowId)
      );
    }
  };

  useEffect(() => {
    const tableBodyScroll = tableBodyRef.current;

    // console.log('tableBodyWidth', tableBodyRef.clientWidth);
    const handleScroll = () => {
      if (tableBodyScroll) {
        const scrollTop = tableBodyScroll.scrollTop;
        setIsHeaderFixed(scrollTop > 0);
        if (tableBodyScroll.scrollWidth > tableBodyScroll.clientWidth) {
          setScrollLeftInside(tableBodyScroll.scrollLeft);
        } else {
          setScrollLeftInside('unset');
        }
      }
    };

    if (tableBodyScroll) {
      tableBodyScroll.addEventListener('scroll', handleScroll);
      window.addEventListener(
        'resize',
        setTableBodyWidth(tableBodyRef.clientWidth)
      );
    }

    return () => {
      if (tableBodyScroll) {
        tableBodyScroll.removeEventListener('scroll', handleScroll);
        window.removeEventListener(
          'resize',
          setTableBodyWidth(tableBodyRef.clientWidth)
        );
      }
    };
  }, [scroll, columns, tableBodyRef]);

  useEffect(() => {
    const tableBodyScroll = tableBodyRef.current;
    if (tableBodyScroll) {
      setTableBodyWidth(tableBodyScroll.clientWidth);
    }
  }, [tableBodyWidth, tableBodyRef, columns]);
  return (
    <table
      ref={tableContainerRef}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minWidth: minWidth,
        border:
          parent === 'addContainerAutobook' ? '1px solid #E1E4EA' : 'none',
        borderRadius: parent === 'addContainerAutobook' ? '4px' : 'none',
        padding: parent === 'addContainerAutobook' ? '0px 8px' : 'none',
      }}>
      <TableHeader
        parent={parent}
        columns={columns}
        tableBodyWidth={tableBodyWidth}
        checkBox={checkBox}
        selectData={handleSelectData}
        action={action || icons}
        check={check}
        isFixed={isHeaderFixed || fixed}
        scrollLeftInside={scrollLeftInside}
        scrollLeft={scrollLeft}
        topScroll={topScroll}
        mini={mini}
        noGap={noGap}
        scroll={scroll}
        width={tableWrapperWidth || width}
        stickyHeader={stickyHeader}
        isHeaderFixed={isHeaderFixed}
        setScrollLeftInside={setScrollLeftInside}
        setScrollLeft={setScrollLeft}
        tableContainerRef={tableContainerRef}
        tableWrapperWidth={tableWrapperWidth}
        componentName={componentName}
      />
      <tbody
        ref={tableBodyRef}
        className={scroll ? styles.tableBodyScroll : styles.tableBody}
        style={{
          marginTop:
            componentName === 'AddNewContainersModal' && isHeaderFixed
              ? '45px'
              : fixed || isHeaderFixed
              ? '50px'
              : '0px',
          gap: noGap ? '0px' : '8px',
          overflowY: componentName === 'YourAppointments' ? 'hidden' : 'auto',
          overflowX: componentName === 'AddNewContainersModal' ? 'hidden' : '',
          flex: 1,
          padding: '0px',
          paddingRight:
            componentName === 'YourAppointments' ||
            componentName === 'EditAutobookContainer'
              ? '0px'
              : componentName === 'AddNewContainersModal' && data.length < 6
              ? '7px'
              : componentName === 'AddNewContainersModal' && data.length >= 6
              ? '15px'
              : '7px',
          maxHeight: maxHeight,
        }}>
        {data?.map((row) => {
          const isDataSelected = selectData?.includes(row.id);

          return (
            <div
              key={row.id}
              className={styles.tableRow}
              style={{
                display: 'flex',
                width: width || 'auto',
                ...getRowStyle?.(row),
                overflow:
                  componentName === 'preApprovecontainers'
                    ? 'unset'
                    : 'visible',
                border:
                  parent === 'addContainerAutobook'
                    ? 'none'
                    : '1px solid #E1E4EA',
                borderBottom:
                  parent === 'addContainerAutobook' ||
                  parent === 'addContainerInbox' ||
                  parent === 'YourAppointments' ||
                  componentName === 'EditAutobookContainer'
                    ? '1px solid #E1E4EA'
                    : 'none',
              }}
              onClick={() => {
                selectData && handleSelectData(row.id);
                if (icons?.[0]?.handleIcon && icons[0].name !== 'trashIcon') {
                  icons[0].handleIcon(row);
                }
              }}>
              {selectData && (
                <div className={styles.checkboxCell}>
                  <input
                    type="checkbox"
                    checked={isDataSelected}
                    value={isDataSelected}
                    style={{
                      width: '16px',
                      height: '16px',
                    }}
                  />
                </div>
              )}
              {columns?.map((col) => (
                <div
                  key={col.field}
                  className={styles.tableRowTd}
                  style={{
                    ...(col.width
                      ? { width: col.width }
                      : col.flex
                      ? { flex: col.flex }
                      : {}),
                    display: 'flex',
                    justifyContent: col.align || 'center',
                    fontSize: col.fontSize,
                  }}>
                  {getCellValue(col, row[col.field], row)}
                </div>
              ))}
              {checkBox && (
                <div className={styles.checkboxCell}>
                  <input
                    type="checkbox"
                    checked={isDataSelected}
                    onChange={() => {}}
                  />
                </div>
              )}
              {action && (
                <div style={{ position: 'relative' }}>
                  <MoreMenu moreActions={action} row={row} />
                </div>
              )}
              {icons && (
                <div
                  className={styles.checkboxCell}
                  style={{
                    flex: 2,
                    minWidth: `${icons?.length * 50}px`,
                    borderRight:
                      parent === 'addContainerAutobook'
                        ? 'none'
                        : '1px solid #E8E8E8',
                  }}>
                  {icons.map((Icon, idx) => (
                    <div
                      key={idx}
                      className={styles.IconContainer}
                      onClick={() => {
                        Icon.handleIcon(row);
                      }}
                      style={{
                        border: noGap ? 'none' : `1px solid ${Icon.color}`,
                      }}>
                      <ReactSVG
                        src={Icons[Icon.name]}
                        className={styles.IconAction}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </tbody>
    </table>
  );
};

export default Table;
